import UiCheckbox from './ui/Checkbox'
import FieldLabel from './ui/FieldLabel'
import React from 'react'

const Checkbox = ({ label, value, setValue, disabled, errors, name }) => {
    return (
        <div className={`checkbox ${errors && errors.includes(name) ? 'error' : ''}`}>
            <UiCheckbox type="checkbox" disabled={disabled} checked={value} onChange={() => setValue(!value)} />
            <FieldLabel choice onClick={() => !disabled && setValue(!value)}> {label}</FieldLabel>
        </div>
    )
}

export default Checkbox